export const css = {
	root: '_3kEH5ITD',
	secondary: '_2Ey0Nc2a',
	required: '_2iEckd0x',
	' _key': 'afcpe-theme/afcpe/dojo/label'
};

export default css;
